import { Button, Typography, CardHeader } from '@mui/material'
import InCardStack from 'components/atoms/container/InCardStack'
import RowStack from 'components/atoms/container/RowStack'
import { USER_CONNECTION_RELATIONSHIP } from 'services/constants'
import { getFullName } from 'utils/formatText'
import ProfileAvatar from 'components/atoms/ProfileAvatar'
import EditRoundedIcon from '@mui/icons-material/EditRounded'
import colors from 'styles/colors'
import { Trans, useTranslation } from 'react-i18next'

export const ConnectionRow = ({ c, setSelected }) => {
  const { t } = useTranslation()
  const isDirectReport =
    c?.relationship === USER_CONNECTION_RELATIONSHIP[0].value
  return (
    <RowStack spacing={8} justifyContent={'space-between'}>
      <CardHeader
        avatar={<ProfileAvatar user={c} />}
        title={<Typography variant='h5'>{getFullName(c)}</Typography>}
        subheader={
          <Typography variant='body1Small' noWrap component='p'>
            {c?.email}
          </Typography>
        }
        sx={{
          flex: 1,
          padding: 0,
          minWidth: 0,
          '& .MuiCardHeader-avatar': {
            marginRight: 4
          },
          '& .MuiCardHeader-content': {
            minWidth: 0
          }
        }}
      />

      <RowStack
        spacing={2}
        sx={{
          width: 'auto',
          borderRadius: 1,
          padding: 2,
          cursor: isDirectReport ? 'default' : 'pointer',
          background: isDirectReport
            ? colors.SecondaryLightGreenStoke
            : colors.Grey
        }}
        onClick={() => {
          if (!isDirectReport) setSelected(c)
        }}>
        <Typography variant='buttonSmall' sx={{ fontWeight: 500 }}>
          {t(`constants.userConnRelationship.${c?.relationship}`)}
        </Typography>
        {!isDirectReport && (
          <EditRoundedIcon
            sx={{
              fontSize: 16,
              cursor: 'pointer'
            }}
          />
        )}
      </RowStack>
    </RowStack>
  )
}

const PopupWrapper = ({ description, actions }) => {
  return (
    <InCardStack spacing={12}>
      <InCardStack spacing={6} alignItems={'flex-start'}>
        {description}
      </InCardStack>
      <RowStack spacing={4} justifyContent='center'>
        {actions}
      </RowStack>
    </InCardStack>
  )
}

export const UpdateConnectionPopupBody = ({
  selected,
  setSelected,
  handleUpdateConn
}) => {
  const { t } = useTranslation()
  const title = getFullName(selected) || selected?.email
  return (
    <PopupWrapper
      description={
        <>
          <Typography variant='h4'>{title}</Typography>
          <Typography>
            <Trans i18nKey='calendarEvents.updateConnType' values={{ title }} />
          </Typography>
        </>
      }
      actions={
        <>
          <Button size='small' color='muted' onClick={() => setSelected(null)}>
            {t('common.cancel')}
          </Button>
          <Button size='small' onClick={handleUpdateConn}>
            {t('contact.update')}
          </Button>
        </>
      }
    />
  )
}

export const SkipPopup = ({ setShowSkip, onConfirm }) => {
  const { t } = useTranslation()
  return (
    <PopupWrapper
      description={
        <>
          <Typography variant='h4'>
            {t('calendarEvents.skipUpdatingConnection')}
          </Typography>
          <Typography>{t('calendarEvents.skippingThisStep')}</Typography>
          <Typography lineHeight={'140%'}>
            {t('calendarEvents.updateConnectionStatusLater')}
          </Typography>
        </>
      }
      actions={
        <>
          <Button size='small' color='muted' onClick={() => onConfirm()}>
            {t('rolePlay.okay')}
          </Button>
          <Button size='small' onClick={() => setShowSkip(false)}>
            {t('common.cancel')}
          </Button>
        </>
      }
    />
  )
}
